// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\ProductResponse

import { ProductPriceBy } from './enums.gen';
import { DateTimefromISO } from '#lib/helper/date.js';
import type { DateTime } from 'luxon';

export type ProductApiResponse = {
	id: string;
	title: string;
	color: string;
	description: string;
	price: number;
	createdAt: string;
	archivedAt: string | null;
	photo: string | null;
	priceOnSite: number;
	priceBy: ProductPriceBy;
	priceMinQuantity: number | null;
	priceMaxQuantity: number | null;
	isMandatory: boolean;
	isRecommended: boolean;
	validPaxMin: number | null;
	validPaxMax: number | null;
	validityDates: string[];
	applyOnAllBookings: boolean;
	applyOnSessions: string[];
	applyOnActivities: string[];
	applyOnOffers: string[];
	sortOrder: number;
};

export type Product = {
	id: string;
	title: string;
	color: string;
	description: string;
	price: number;
	createdAt: DateTime;
	archivedAt: DateTime | null;
	photo: string | null;
	priceOnSite: number;
	priceBy: ProductPriceBy;
	priceMinQuantity: number | null;
	priceMaxQuantity: number | null;
	isMandatory: boolean;
	isRecommended: boolean;
	validPaxMin: number | null;
	validPaxMax: number | null;
	validityDates: string[];
	applyOnAllBookings: boolean;
	applyOnSessions: string[];
	applyOnActivities: string[];
	applyOnOffers: string[];
	sortOrder: number;
};

export function hydrateProduct(data: ProductApiResponse): Product {
	return {
		...data,
		createdAt: DateTimefromISO(data.createdAt)!,
		archivedAt: DateTimefromISO(data.archivedAt),
	};
}